"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEachValidBatchItem = void 0;
const lodash_1 = __importDefault(require("lodash"));
/**
 * Iterates over all valid batch items (including set items) in confirmed batches.
 * Only processes batches with status 'submitted' or 'confirmed'.
 */
function forEachValidBatchItem(batches, callback) {
    lodash_1.default.forEach(batches, batch => {
        if (['submitted', 'confirmed'].includes(batch.status)) {
            batch.items.forEach(item => {
                callback(item);
                lodash_1.default.forEach(item.setItems, setItem => {
                    callback(setItem);
                });
            });
        }
    });
}
exports.forEachValidBatchItem = forEachValidBatchItem;
//# sourceMappingURL=calculateLocalOrerUtil.js.map